/* unplugin-vue-components disabled */import __unplugin_components_2 from '/var/repos/bic-vue/src/components/configurator/topbar/MainObjectEditor.vue';
import __unplugin_components_1 from '/var/repos/bic-vue/src/components/configurator/topbar/ShapesObjectEditor.vue';
import __unplugin_components_0 from '/var/repos/bic-vue/src/components/configurator/topbar/TextObjectEditor.vue';
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "cmp__top-configurator-toolbar"
};
const _hoisted_2 = {
  class: "object-related-toolbar"
};
import { useConfigurationStore } from '@/stores/configurationModule';
import { useConfiguratorStore } from '@/stores/configurator';
import { useWindowSize } from '@vueuse/core';
export default {
  __name: 'EditorToolbar',
  setup(__props) {
    const configurationStore = useConfigurationStore();
    const {
      activeObjects
    } = storeToRefs(configurationStore);
    const configuratorStore = useConfiguratorStore();
    const {
      mobileBreakpoint
    } = storeToRefs(configuratorStore);
    const {
      width: windowWidth
    } = useWindowSize();
    const availableShapesForObjectEditor = ['rectangle', 'circle', 'triangle', 'hexagon', 'trapezoid', 'line'];
    const hasActiveObjects = computed(() => activeObjects.value.length > 0);
    // const activeObjectType = computed(() => activeObjects.value[0]?.objectType);

    const showTextObjectEditor = computed(() => hasActiveObjects.value && activeObjects.value.every(ao => ao.objectType === 'text'));
    const showShapesObjectEditor = computed(() => hasActiveObjects.value && activeObjects.value.every(ao => availableShapesForObjectEditor.includes(ao.objectType)));
    return (_ctx, _cache) => {
      const _component_TextObjectEditor = __unplugin_components_0;
      const _component_ShapesObjectEditor = __unplugin_components_1;
      const _component_MainObjectEditor = __unplugin_components_2;
      return _unref(windowWidth) > _unref(mobileBreakpoint) ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_unref(showTextObjectEditor) ? (_openBlock(), _createBlock(_component_TextObjectEditor, {
        key: 0
      })) : _createCommentVNode("", true), _unref(showShapesObjectEditor) ? (_openBlock(), _createBlock(_component_ShapesObjectEditor, {
        key: 1,
        class: "ml-6"
      })) : _createCommentVNode("", true)]), _unref(hasActiveObjects) ? (_openBlock(), _createBlock(_component_MainObjectEditor, {
        key: 0,
        class: "ml-auto"
      })) : _createCommentVNode("", true)])) : _createCommentVNode("", true);
    };
  }
};